module.exports = __webpack_public_path__ + "static/media/img19.d087559d.JPG";